import React from 'react'
import { Button, Row, Space, Tooltip } from 'antd'

import './index.scss'
import { useHistory } from 'react-router-dom'
import { NavigationLeftIco } from '../../../modules/CustomIcons'

const GoBack: React.FC<any> = (props: any) => {
  const history = useHistory()

  return (
    <Row style={{ marginBottom: 20, gap: 20 }} align="middle">
      <div
        className="transfer__title flex justify_between align_center"
        style={{ margin: 0,width:'100%' }}
      >
        <div className={'flex align_center'}>
          <Button
            type={'ghost'}
            className={'transparent'}
            icon={<NavigationLeftIco />}
            onClick={() => {
              history.push('/')
            }}
          />
          <p>{props.title}</p>
        </div>

        {props?.extraData}
      </div>

      {props?.icon}
    </Row>
  )
}

export default GoBack
